import React, { useState } from 'react';

import BrandList from '@features/crm/brands/BrandList';
import FilterComponent from '@features/crm/components/FilterComponent';

import { crmTabs } from '@utils/Util';

const Brands = () => {
	const [openModal, setOpenModal] = useState(false);

	return (
		<>
			<div className="top-header bg-white">
				<FilterComponent activeTab={crmTabs.BRANDS} setOpenModal={setOpenModal} />
			</div>
			<BrandList openModal={openModal} triggerModal={setOpenModal} />
		</>
	);
};

export default Brands;
